import { useDocumentService } from "contexts/ServiceContext";
import { AI_EVENTS, useTrackEvent } from "../../useAppInsight";
import { useMutation } from "@tanstack/react-query";
import { mapApiExportReportParams } from "./useGetFormattedCsv";

const useSendCsvEmail = (cardCodes: string[]) => {
  const documentService = useDocumentService();
  const trackQuery = useTrackEvent(AI_EVENTS.API_REQUEST, {
    cardCodes,
  });
  const trackQueryError = useTrackEvent(AI_EVENTS.API_ERROR, {
    cardCodes,
  });

  return useMutation({
    mutationKey: ["send-csv-email", cardCodes],
    mutationFn: (exportCsvParams: DownloadCsvParams) => {
      const eventId = trackQuery({
        endpoint: "/api/Report/SendEmail",
      });
      return documentService
        .sendCsvEmail(mapApiExportReportParams(exportCsvParams))
        .catch((err) => {
          trackQueryError({ message: err.message }, eventId);
          throw err;
        });
    },
  });
};

export default useSendCsvEmail;
